import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { formatColumnsAsStyles } from "../particle";
var getSpacingDirection = function(spacingDirection) {
    return ({
        bottom: /*#__PURE__*/ css("margin-bottom:1rem;"),
        both: /*#__PURE__*/ css("margin-bottom:1rem;margin-top:1rem;"),
        top: /*#__PURE__*/ css("margin-top:1rem;"),
        neither: ""
    })[spacingDirection];
};
var HeadingWrapper = /*#__PURE__*/ styled("div", {
    target: "enix2q50"
})(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";", function(param) {
    var rules = param.rules;
    var ref;
    return ((ref = rules.verticalSpacing) === null || ref === void 0 ? void 0 : ref.spacingDirection) ? getSpacingDirection(rules.verticalSpacing.spacingDirection) : getSpacingDirection("bottom");
}, ";", function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && "\n    & > h1, h2, h3 {\n      display: flex;\n      align-items: center;\n      column-gap: 1rem;\n    }\n    ";
});
export { HeadingWrapper };
